import { DELETE_KIOSK_THEME, DELETE_LOCATION_THEME } from '../../../graphql/mutations';

import { CustomizeThemeLocalizationEntityLevel } from '../../../enums/CustomizeThemeLocalizationEntityLevel';
import { DELETE_TENANT_THEME } from '../../../graphql/mutations/tenant';
import { DocumentNode } from 'graphql';
import { NotSupportedError } from '../constants/defaultError';

const getDeleteQuery = (entityLevel: CustomizeThemeLocalizationEntityLevel): DocumentNode => {
  switch (entityLevel) {
    case CustomizeThemeLocalizationEntityLevel.TENANT:
      return DELETE_TENANT_THEME;

    case CustomizeThemeLocalizationEntityLevel.LOCATION:
      return DELETE_LOCATION_THEME;

    case CustomizeThemeLocalizationEntityLevel.KIOSK:
      return DELETE_KIOSK_THEME;

    default:
      throw NotSupportedError(entityLevel);
  }
};

export default getDeleteQuery;
